/*global CustomFunctions */
import { isGuid, formulaErrorHandling } from "../../shared/helpers";
import { FormulaErrorFormat } from "../../shared/types";
import { observerForCustomFunction } from "../../shared/query-client";
import { HIERARCHY_REFS_BY_ASSET_ID_BATCHER } from "../../shared/batchers";

/**
 * Gets DDB asset path.
 * @customfunction ASSET.PATH
 * @param assetId The asset ID.
 * @param [separator] The separator to use. If omitted = "/"
 * @returns The asset path.
 * @streaming
 */
export function assetPath(
  assetId: string,
  separator: string | null,
  invocation: CustomFunctions.StreamingInvocation<string>
): void {
  if (!separator) {
    separator = "/";
  }

  if (!isGuid(assetId)) {
    invocation.setResult(formulaErrorHandling(FormulaErrorFormat.ASSET_ID));
    return;
  }

  observerForCustomFunction(invocation, {
    queryKey: ["hierarchy", assetId],
    queryFn: async () => HIERARCHY_REFS_BY_ASSET_ID_BATCHER.fetch(assetId),
    select: ({ hierarchy }) => hierarchy?.map(({ name }) => name).join(separator),
  });
}

CustomFunctions.associate("ASSET.PATH", assetPath);